import React from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { showOutcome, hideOutcome } from "../../dux/settings/actions";

const MetricCheckbox = ({ metric, selected = false }) => {
  const dispatch = useDispatch();
  return (
    <>
      <Form.Check
        type="checkbox"
        id={metric.outcome_slug}
        label={metric.title}
        checked={selected}
        onChange={(e) => {
          if (selected) {
            dispatch(showOutcome(metric.outcome_slug));
          } else {
            dispatch(hideOutcome(metric.outcome_slug));
          }
        }}
      />
    </>
  );
};

export default MetricCheckbox;
